import { useReveal } from '../hooks/useReveal';
import './Contact.css';

export default function Contact() {
  const revealRef = useReveal();

  return (
    <section className="contact-section" ref={revealRef}>
      <div className="container">
        <div className="sec-head">
          <div className="reveal sec-eyebrow">Reach Out</div>
          <h1 className="reveal contact-title">Get in <em className="gold-em">Touch</em></h1>
          <p className="reveal sec-sub">
            We'd love to hear from you. Reach out anytime and we'll respond quickly.
          </p>
        </div>

        <div className="contact-grid">
          {/* Info Card */}
          <div className="contact-info reveal">
            <h2 className="c-h2">Let's Talk</h2>
            <p className="c-intro">
              Whether you want to explore a demo, discuss a custom solution, or just learn more
              about our AI-powered products — we're here for you.
            </p>

            <div className="c-row">
              <div className="c-icon"><img src="/address.png" alt="Address" /></div>
              <div>
                <div className="c-label">Address</div>
                <div className="c-val">314B, JanaPriya Township, Mallapur,<br />Hyderabad, Telangana, 500076, India</div>
              </div>
            </div>

            <div className="c-row">
              <div className="c-icon"><img src="/phone.png" alt="Phone" /></div>
              <div>
                <div className="c-label">Phone</div>
                <div className="c-val">
                  <a href="tel:+918121325297">+91 8121325297</a>
                </div>
              </div>
            </div>

            <div className="c-row">
              <div className="c-icon"><img src="/email.png" alt="Email" /></div>
              <div>
                <div className="c-label">Email</div>
                <div className="c-val">
                  <a href="mailto:info@visiontechnoservices.com">info@visiontechnoservices.com</a>
                </div>
              </div>
            </div>

            <div className="c-row">
              <div className="c-icon c-icon-emoji">🕐</div>
              <div>
                <div className="c-label">Business Hours</div>
                <div className="c-val">Mon – Sat: 9:00 AM – 7:00 PM<br />Sunday: Closed</div>
              </div>
            </div>
          </div>

          {/* Map */}
          <div className="map-box reveal">
            <iframe
              src="https://www.google.com/maps?q=314B,+JanaPriya+Township,+Mallapur,+Hyderabad,+Telangana,+500076,+India&output=embed"
              title="Vision Techno Services Office"
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            />
          </div>
        </div>
      </div>
    </section>
  );
}
